import styled from "styled-components";

export const ModalMainStyled = styled.div`

`;

export const ModalMainBodyStyled = styled.div`
    padding: 10px;
`;